import { defineComponent as _defineComponent } from 'vue'
import BravadoTheme from '@/components/common/BravadoTheme/BravadoTheme.vue';

type BlackModalProps = {
  persistent?: boolean;
  variant?: 'screen-bottom' | 'default';
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalBlack',
  props: {
    persistent: { type: Boolean, default: false },
    variant: { default: 'default' }
  },
  setup(__props: any) {



return { __sfc: true,BravadoTheme }
}

})